import React from 'react'
import { PropTypes } from 'prop-types'
import classNames from 'classnames'

import { SubCategoryItem, SubCategoryCarousel } from '../..'

function DesktopView({ subcategories = [], isFullWidth = false }) {
  const containerClasses = classNames('position-relative mb-4', {
    container: !isFullWidth,
  })
  return (
    <div className={containerClasses}>
      <SubCategoryCarousel>
        {subcategories.map((subcategory, key) => (
          <SubCategoryItem
            key={key}
            link={subcategory.catLink}
            name={subcategory.catName}
          />
        ))}
      </SubCategoryCarousel>
    </div>
  )
}

DesktopView.propTypes = {
  subcategories: PropTypes.arrayOf(
    PropTypes.shape({
      catLink: PropTypes.string,
      catName: PropTypes.string,
    })
  ),
  isFullWidth: PropTypes.bool,
}

export default DesktopView
